import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { useGetMenuMaster } from 'api/menu';
import { clearAuthentication } from 'utils/auth';
import ExportOutlined from '@ant-design/icons/ExportOutlined';

export default function SidebarLogout() {
  const navigate = useNavigate();
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  const handleLogout = () => {
    clearAuthentication();
    navigate('/login', { replace: true });
  };

  return (
    <Box
      sx={{
        flexShrink: 0,
        mt: 'auto',
        px: 0,
        pt: 0,
        pb: 0,
        maxWidth: '100%',
        overflow: 'visible',
        borderTop: '1px solid #e0e0e0',
        bgcolor: '#ffffff'
      }}
    >
      <Button
        fullWidth
        className="sidebar-logout-btn"
        variant="contained"
        onClick={handleLogout}
        aria-label="Log out"
        startIcon={drawerOpen ? <ExportOutlined style={{ fontSize: 18 }} /> : undefined}
        disableElevation
        sx={{
          bgcolor: '#ff6600',
          color: '#fff',
          py: 1.35,
          px: drawerOpen ? 2 : 0.5,
          textTransform: 'none',
          fontWeight: 600,
          boxShadow: 'none',
          minWidth: 0,
          borderRadius: 0,
          '&:hover': { bgcolor: '#e65c00', boxShadow: 'none' }
        }}
      >
        {drawerOpen ? 'Log out' : <ExportOutlined style={{ fontSize: 18 }} />}
      </Button>
    </Box>
  );
}
